import { useNavigate } from '@tanstack/react-router';
import { metaMask } from '@wagmi/connectors';
import { connect } from '@wagmi/core';
import { useState } from 'react';

import { config } from '~/config/wagmi';
import type { OriginName } from '~/interfaces/common';
import { setLocalStorageItem } from '~/utils/local-storage';

import { initiateAuthentication } from '../-api/api';

export function useLogin() {
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleLogin = async (alias: string, originName: OriginName) => {
    setIsLoading(true);
    setError(null);

    try {
      const res = await initiateAuthentication(originName, alias);
      if (!res) {
        setError('Error al iniciar sesión');
        return;
      }

      setLocalStorageItem('alias', alias);
      setLocalStorageItem('originName', originName);
      setLocalStorageItem('originalChallengeParams', res.value);
      setLocalStorageItem('authFlow', 'login');

      if (originName.includes('bloque-whatsapp')) {
        const whatsappType = originName.includes('quick')
          ? 'whatsapp-quick'
          : 'whatsapp';
        navigate({
          to: '/auth/otp/$origin-name',
          params: { 'origin-name': whatsappType },
          search: {
            alias,
          },
        });
        return;
      }

      if (originName === 'bloque-email') {
        navigate({
          to: '/auth/otp/$origin-name',
          params: { 'origin-name': 'email' },
          search: {
            alias,
          },
        });
        return;
      }

      if (originName === 'evm') {
        await connect(config, { connector: metaMask() });
        return;
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Error al iniciar sesión');
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    error,
    handleLogin,
  };
}
